
import i18nGlobal from '@/i18ns/i18n';
import optionAPI from '@/apis/other/optionAPI';
import { ItemKey, OptionKey } from '@/commons/enumManual.js';
import { OptionValueType } from '@/commons/enumUserOption.js';

const i18n = i18nGlobal.global;

const ITEMS = [
  {
    key: ItemKey.ConfigGeneralSetting,
    title: i18n.t('i18nManual.ConfigGeneralSetting.Title'),
    isViewed: false,
    desc: i18n.t('i18nManual.ConfigGeneralSetting.Desc'),
    btnNavigate: i18n.t('i18nManual.ConfigGeneralSetting.BtnNavigate'),
    routeName: 'general-setting',
    arrowTop: '178px',
  },
  {
    key: ItemKey.AddDepartment,
    title: i18n.t('i18nManual.AddDepartment.Title'),
    isViewed: false,
    desc: i18n.t('i18nManual.AddDepartment.Desc'),
    btnNavigate: i18n.t('i18nManual.AddDepartment.BtnNavigate'),
    routeName: 'department-list',
    arrowTop: '32px',
  },
  {
    key: ItemKey.AddUser,
    title: i18n.t('i18nManual.AddUser.Title'),
    isViewed: false,
    desc: i18n.t('i18nManual.AddUser.Desc'),
    btnNavigate: i18n.t('i18nManual.AddUser.BtnNavigate'),
    routeName: 'user',
    arrowTop: '82px',
  },
  {
    key: ItemKey.ConfigUserRole,
    title: i18n.t('i18nManual.ConfigUserRole.Title'),
    isViewed: false,
    desc: i18n.t('i18nManual.ConfigUserRole.Desc'),
    btnNavigate: i18n.t('i18nManual.ConfigUserRole.BtnNavigate'),
    routeName: 'role',
    arrowTop: '130px',
  },
]

export default {
  namespaced: true,
  state: () => ({
    items: ITEMS,
    isActiveFloatingBtn: false,
  }),
  getters: {
    /**
     * Số lượng item chưa xem
     * @param {*} state 
     * @returns Số lượng item chưa xem
     * @author: BMThang(03/04/2023)
     */
    unwatchItemAmount: (state) => {
      return state.items.reduce((prev, cur) => {
        if (cur.isViewed) return prev;
        return prev + 1;
      }, 0)
    },

    /**
     * Có hiện floating btn ko
     * @param {*} state 
     * @author: BMThang(03/04/2023)
     */
    isShowFloatingBtn: (state, getter) => {
      return state.isActiveFloatingBtn && (getter.unwatchItemAmount > 0);
    },
  },
  mutations: {
    /**
     * Hiện floating btn
     * @param {*} state 
     * @author: BMThang(03/04/2023)
     */
    showFloatingBtn: (state) => {
      state.isActiveFloatingBtn = true;
    },

    /**
     * Ẩn floating btn
     * @param {*} state 
     * @author: BMThang(03/04/2023)
     */
    hideFloatingBtn: (state) => {
      state.isActiveFloatingBtn = false;
    },

    /**
     * Xét items
     * @param {*} state 
     * @author: BMThang(03/04/2023)
     */
    setItems: (state, items) => {
      state.items = items;
    },
  },
  actions: {
    /**
     * Lấy danh sách key item đã đc xem
     * @param {*}  
     * @author: BMThang(03/04/2023)
     */
    getViewedItems: async ({ commit, rootState }) => {
      // Nếu ko phải admin thì cook
      if (!rootState.context.User.IsAdmin) return;
      try {
        const res = await optionAPI.getDbOptions(OptionKey);
        const viewedItemKeys = Array.isArray(res.OptionValue) ? res.OptionValue : [];
        const newItems = ITEMS.map((item) => ({
          ...item,
          isViewed: viewedItemKeys.includes(item.key)
        }))
        commit('setItems', newItems);
      } catch {
        commit('setItems', ITEMS);
      }
    },

    /**
     * Xét item đc xem
     * @param {*}  
     * @param {*}  
     * @author: BMThang(03/04/2023)
     */
    setViewedItem: async ({ commit, state }, itemKey) => {
      const newItems = state.items.map(item => ({
        ...item,
        isViewed: item.key === itemKey ? true : item.isViewed,
      }))
      const viewedItemKeys = [];
      newItems.forEach(item => {
        if (item.isViewed)
          viewedItemKeys.push(item.key)
      });
      try {
        await optionAPI.updateDbOptions({
          model: {
            optionKey: OptionKey,
            optionValueType: OptionValueType.Object,
            optionValue: viewedItemKeys,
          },
        });
        commit('setItems', newItems);
      } catch {
        commit('setItems', state.items);
      }
    },

    /**
     * Reset các item đc xem
     * @param {*}  
     * @param {*}  
     * @author: BMThang(03/04/2023)
     */
    resetViewedItems: async ({ commit }) => {
      try {
        await optionAPI.updateDbOptions({
          model: {
            optionKey: OptionKey,
            optionValueType: OptionValueType.Object,
            optionValue: [],
          },
        });
      } finally {
        commit('setItems', ITEMS);
      }
    },
  },
}